export default "__VITE_ASSET__k$PV4hsY__"